import React, { useState, useEffect } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "./images/cr-transparent.png"; // adjust path

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("theme") === "dark");
  const [menuOpen, setMenuOpen] = useState(false);

  // Apply dark mode class
  useEffect(() => {
    const root = document.documentElement;
    if (darkMode) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  // Handle navigation with hash + cross-page support
  const handleNav = (hash, path = "/") => {
    setMenuOpen(false);

    if (location.pathname !== path) {
      navigate(path + hash);
    } else {
      const el = document.querySelector(hash);
      if (el) {
        const headerHeight = document.querySelector("header")?.offsetHeight || 80;
        const topPos = el.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top: topPos, behavior: "smooth" });
      }
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center cursor-pointer" onClick={() => handleNav("#top", "/")}>
          <img src={logo} alt="CodeRocker Logo" className="h-7 sm:h-7" />
        </div>

        {/* Desktop Nav */}
        <nav className="hidden sm:flex items-center gap-6 font-medium text-white">
          <button onClick={() => handleNav("#top", "/")} className="hover:text-gray-200">Home</button>
          <button onClick={() => handleNav("#code-snippets", "/")} className="hover:text-gray-200">Code Snippets</button>
          <button onClick={() => handleNav("#blogs", "/")} className="hover:text-gray-200">Blogs</button>
        </nav>

        {/* Theme toggle */}
        <div className="hidden sm:flex items-center gap-3">
          <span className="text-xs">☀️</span>
          <button
            onClick={() => setDarkMode(!darkMode)}
            className="relative w-14 h-8 flex items-center bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 rounded-full p-1 transition-colors duration-300"
          >
            <div
              className={`w-6 h-6 bg-gradient-to-r from-yellow-300 to-yellow-500 dark:from-indigo-500 dark:to-purple-600 rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${
                darkMode ? "translate-x-6" : "translate-x-0"
              }`}
            ></div>
          </button>
          <span className="text-xs">🌙</span>
        </div>

        {/* Mobile Hamburger */}
        <div className="sm:hidden flex items-center">
          <button onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <HiX size={28} /> : <HiMenu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="sm:hidden bg-indigo-600 dark:bg-gray-800 text-white px-4 py-4 flex flex-col gap-3">
          <button onClick={() => handleNav("#top", "/")} className="text-left">Home</button>
          <button onClick={() => handleNav("#code-snippets", "/")} className="text-left">Code Snippets</button>
          <button onClick={() => handleNav("#blogs", "/")} className="text-left">Blogs</button>
          <div className="flex items-center gap-3 mt-2">
            <span className="text-xs">☀️</span>
            <button
              onClick={() => setDarkMode(!darkMode)}
              className="relative w-14 h-8 flex items-center bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 rounded-full p-1 transition-colors duration-300"
            >
              <div
                className={`w-6 h-6 bg-gradient-to-r from-yellow-300 to-yellow-500 dark:from-indigo-500 dark:to-purple-600 rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${
                  darkMode ? "translate-x-6" : "translate-x-0"
                }`}
              ></div>
            </button>
            <span className="text-xs">🌙</span>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
